import {KeycloakService} from 'keycloak-angular';
import {Component, ElementRef, HostListener, OnInit, ViewChild} from '@angular/core';
import {animate, style, transition, trigger} from '@angular/animations';
import {Router} from '@angular/router';
import {AuthService} from '../../services/auth.service';
import {register as registerSwiperElements} from 'swiper/element/bundle';
import {Review} from '../../models/review.model';
import {StatsService} from '../../services/stats.service';

registerSwiperElements();

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css'],
  animations: [
    trigger('slideDown', [
      transition(':enter', [
        style({ height: 0, opacity: 0 }),
        animate('250ms ease-out', style({ height: '*', opacity: 1 }))
      ]),
      transition(':leave', [
        animate('200ms ease-in', style({ height: 0, opacity: 0 }))
      ])
    ])
  ]
})
export class HomeComponent implements OnInit {
  cards = [
    {
      image: 'https://via.placeholder.com/300x200',
      title: 'Título 1',
      description: 'Descrição do card 1.'
    },
    {
      image: 'https://via.placeholder.com/300x200',
      title: 'Título 2',
      description: 'Descrição do card 2.'
    },
    {
      image: 'https://via.placeholder.com/300x200',
      title: 'Título 3',
      description: 'Descrição do card 3.'
    },

  ];

  colClass: string = 'col-4';
  activeIndex: number | undefined = 0;

  valorBusca: string = '';

  mostrarPainel = false;
  @ViewChild('painelContainer') painelRef!: ElementRef;


  isLoggedIn: boolean = false;

  reviews: Review[] = [];

  // Categorias
  categories: string[] = [
    'Categoria 1', 'Categoria 2', 'Categoria 3',
    'Categoria 4', 'Categoria 5', 'Categoria 6'
  ];
  selectedCategories: string[] = [];
  searchTerm: string = '';

  constructor(
    private router: Router,
    private stats: StatsService,
    private keycloakService: KeycloakService,
    private authService: AuthService
  ) {}

  ngOnInit(): void {
    this.checkLogin();
    this.loadReviews();
    this.updateColClass(window.innerWidth);
  }

  // Verifica se o usuário está autenticado pelo Keycloak
  async checkLogin(): Promise<void> {
    try {
      this.isLoggedIn = this.keycloakService.isLoggedIn();
    } catch (error) {
      console.error('Erro ao verificar login:', error);
      this.isLoggedIn = false;
    }
  }

  loadReviews(): void {
    this.isLoggedIn = this.authService.isAuthenticated();
    this.carregarAvaliacoes();
    this.updateColClass(window.innerWidth);
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.updateColClass(event.target.innerWidth);
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: Event) {
    if (this.mostrarPainel && this.painelRef) {
      const clickedInside = this.painelRef.nativeElement.contains(event.target);
      if (!clickedInside) {
        this.mostrarPainel = false;
      }
    }
  }

  // Responsividade
  private updateColClass(width: number) {
    if (width < 1024) {
      this.colClass = 'col-6';
    } else if (width < 1400) {
      this.colClass = 'col-4';
    } else {
      this.colClass = 'col-3';
    }
  }

  private carregarAvaliacoes() {
    this.stats.getTop10().subscribe({
      next: (res) => {
        const data = res?.data ?? res;
        const content = data?.content ?? (Array.isArray(data) ? data : []);
        const isEmpty = data?.empty ?? (content.length === 0);
        if (!isEmpty && Array.isArray(content)) {
          content.forEach((r: any) => {
            const promptView = r?.promptView ?? r;
            if (!promptView?.usuario) return;
            const review: Review = new Review();
            review.avatar = promptView.usuario.usuario_base64_arqfoto
              ? `data:image/png;base64,${promptView.usuario.usuario_base64_arqfoto}`
              : '../../../assets/imagem/avatar3.jpg';
            review.name = promptView.usuario.usuario_apelido ?? promptView.usuario.usuario_nome ?? '';
            review.title = promptView.prompt_titulo ?? '';
            review.id = promptView.prompt_id;
            review.quote = promptView.usuario.usuario_frase ?? '';
            review.rating = r?.avgValorAvaliacao ?? 0;
            review.status = `Top ${r?.qtdeAvaliacoes ?? 0} dos usuários`;
            this.reviews.push(review);
          });
        }
      },
      error: (err) => {
        console.warn('Top10 não carregou. Verifique se o BFF expõe GET /dados/top10 ou /avaliacao/top10.', err);
      },
    });
  }


  activeIndexChange(index: number): void {
    this.activeIndex = index;
  }


  // Categorias
  filteredCategories(): string[] {
    return this.categories.filter(cat =>
      cat.toLowerCase().includes(this.searchTerm.toLowerCase())
    );
  }

  onCategoryChange() {
    this.selectedCategories = [...new Set(this.selectedCategories)];
  }

  removeCategory(category: string) {
    this.selectedCategories = this.selectedCategories.filter(c => c !== category);
  }

  clearSelection() {
    this.selectedCategories = [];
  }

  applySelection() {
    this.mostrarPainel = false;
  }

  togglePainel() {
    this.mostrarPainel = !this.mostrarPainel;
  }

  selecionarTema(tema: string) {
    this.mostrarPainel = false;
  }

  // Método para busca: se não estiver logado, redireciona para o login
  async buscar(): Promise<void> {
    const loggedIn = this.keycloakService.isLoggedIn();
    if (!loggedIn) {
      this.router.navigate(['/'], {
        queryParams: {
          returnUrl: this.keycloakService.login(),
          search: this.valorBusca,
        },
      });
      return;
    }
    this.router.navigate(['/resultados-busca'], {
      queryParams: { search: this.valorBusca },
    });
  }
   async telaPrompt(reviewId: string): Promise<void> {
    
    const loggedIn = this.keycloakService.isLoggedIn();
      
    if (!loggedIn) {
      this.router.navigate(['/'], {
      queryParams: {
        returnUrl: this.keycloakService.login(),
        search: this.valorBusca,
      },
    });
    return;
    }
      
    this.router.navigate(['/tela-prompt', reviewId]);
  }

}
